import './style.scss'
import { useContext, useEffect, useState } from 'react';
import utility from 'src/utils/utility'
import { useNavigate } from 'react-router-dom';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import ApiContext from 'src/provider/API/call-service';
import { AppSpan, AppText, CustomContainer, FlexRow, ScreenContainer, ScreenTitle } from 'src/style';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import moment from 'moment';
import {ReactComponent as CustomerIcon} from 'src/assets/svg/customer-sm-icon.svg'
import {ReactComponent as ArrowUpRight} from 'src/assets/svg/arrow-right-circle.svg'
import {ReactComponent as ArrowDownRight} from 'src/assets/svg/arrow-down-right-circle.svg'
import {ReactComponent as MapIconGreen} from 'src/assets/svg/map-icon-green.svg'
import {ReactComponent as MapIconYellow} from 'src/assets/svg/map-icon-yellow.svg'
import LocationMap from 'src/assets/svg/users-location-map.svg'
import { DoughnutChart, VerificationChart } from 'src/component';
import { topUsers } from 'src/utils/mockData';
import { dashboardStats, verificationChart, locationStats, Devices } from 'src/model';


export const IndividualHome: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {organization}} = useContext(AppInfoContext)
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment().add(7, 'd'));
    const [focusedInput, setFocusedInput] = useState(null);
    const [addressStats, setAddressStats] = useState<dashboardStats | null>(null)
    const [verificationChart, setVerificationChart] = useState<verificationChart | null>(null)
    const [deviceStats, setDeviceStats] = useState<any>({})
    const [locationStats, setLocationStats] = useState<Array<locationStats> | null>(null)

    useEffect(() => {
        if (organization.id) handleFetchDashboardInfo()
    }, [organization])

    function onDateChange({startDate, endDate}: any) {
        setStartDate(startDate);
        setEndDate(endDate);
        
        if (startDate && endDate && focusedInput === 'endDate') {
            const from = startDate.toISOString()?.split('T')[0]
            const to = endDate.toISOString()?.split('T')[0]

            handleFetchDashboardInfo({from, to})
        }
    }

    function onFocusChange(focusedInput: any) {
        setFocusedInput(focusedInput);
    }

    async function handleFetchDashboardInfo (dateRange = {}, year?: string) {
        const addressStats = await API.getAddressStats(dateRange)
        const verificationChart = await API.getVerificationChart(year)
        const deviceStats = await API.getDeviceStats(dateRange)
        const locationStats = await API.getLocationStats(dateRange)

        if (addressStats) setAddressStats(addressStats)
        if (verificationChart) setVerificationChart(verificationChart)
        if (deviceStats) {
            const devices: Devices = {macos: 0, android: 0, windows: 0, api: 0, ios: 0}

            for (let item of deviceStats) {
                devices[item.device as keyof Devices] = item.count
            }

            const {macos, android, windows, api, ios} = devices
            const total = macos + android + api + windows + ios
            
            if (total != 0) {
                devices.macos = Number(((macos/total) * 100).toFixed(1))
                devices.android = Number(((android/total) * 100).toFixed(1))
                devices.windows = Number(((windows/total) * 100).toFixed(1))
                devices.api = Number(((api/total) * 100).toFixed(1))
                devices.ios = Number(((ios/total) * 100).toFixed(1))
            }

            setDeviceStats(devices)
        }
        if (locationStats) setLocationStats(locationStats)
    }

    return (
        <ScreenContainer padding='2.5'>
            <ScreenTitle 
                color='#333333' 
                textSize='2.4' 
                fontWeight='700'
                bottomMargin='4'
            >
                Dashboard
            </ScreenTitle>

            <FlexRow 
                justifyContent='space-between'
                wrap='wrap'
                gap='3'
            >
                <AppSpan textSize='1.8' color='#333333'>Hello Ridwaan</AppSpan>
                <DateRangePicker
                    startDate={startDate}
                    startDateId="start_date"
                    endDate={endDate}
                    endDateId="end_date"
                    onDatesChange={onDateChange}
                    focusedInput={focusedInput}
                    onFocusChange={onFocusChange}
                    isOutsideRange={() => false}
                />
            </FlexRow>
            <CustomContainer 
                topMargin='2'
                className='scrollable-container-plus' 
            >
                <CustomContainer
                    overflow='auto'
                    style={{display: 'inline-block'}}
                >
                    <FlexRow 
                        gap='1.5'
                        alignItems='stretch' 
                        style={{minWidth: 'fit-content'}}
                    >
                        <CustomContainer
                            width='33.8'
                            minHeight='16.1'
                            radius='0.8'
                            bgColor='#F3F0FF'
                            padding='1.5'
                            style={{borderLeft: '4px solid #5627FF'}}
                        >
                            <FlexRow 
                                justifyContent='space-between'
                                alignItems='flex-start'
                                gap='2.5'
                            >
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppSpan textSize='#282828'>All Customers</AppSpan>
                                    <AppText textSize='2.4' color='#333333' fontWeight='700'>
                                        {addressStats?.customers?.total}
                                    </AppText>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit='' topMargin='0.5'>
                                    <CustomerIcon className='icon-component' />
                                </CustomContainer>
                            </FlexRow>
                            <FlexRow 
                                justifyContent='space-between' 
                                alignItems='flex-start' 
                                topMargin='3'
                                gap='3'
                                className='scroll-x-text'
                            >
                                <AppText textSize='1.2' color='#333333'>
                                    2,000,000 more customer in the last 7 days
                                </AppText>
                                <FlexRow width='auto' sizeUnit='' gap='0.3'>
                                    <AppSpan textSize='1.2' color='#333333' fontWeight='700'>
                                        {addressStats?.customers?.rate}%
                                    </AppSpan>
                                    <ArrowUpRight className='icon-component' />
                                </FlexRow>
                            </FlexRow>
                        </CustomContainer>

                        <CustomContainer
                            width='33.8'
                            minHeight='16.1'
                            radius='0.8'
                            bgColor='#ECFCF3'
                            padding='1.5'
                            style={{borderLeft: '4px solid #27AE60'}}
                        >
                            <FlexRow 
                                justifyContent='space-between'
                                alignItems='flex-start'
                                gap='2.5'
                            >
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppSpan textSize='#282828'>Verified Addresses</AppSpan>
                                    <AppText textSize='2.4' color='#333333' fontWeight='700'>
                                        {addressStats?.verifiedAddresses?.total}
                                    </AppText>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit='' topMargin='0.5'>
                                    <MapIconGreen className='icon-component' />
                                </CustomContainer>
                            </FlexRow>
                            <FlexRow 
                                justifyContent='space-between' 
                                alignItems='flex-start' 
                                topMargin='3'
                                gap='3'
                                className='scroll-x-text'
                            >
                                <AppText textSize='1.2' color='#333333'>
                                    Verification Rate
                                </AppText>
                                <FlexRow width='auto' sizeUnit='' gap='0.3'>
                                    <AppSpan textSize='1.2' color='#333333' fontWeight='700'>
                                        {addressStats?.verifiedAddresses?.rate}%
                                    </AppSpan>
                                    <ArrowUpRight className='icon-component' />
                                </FlexRow>
                            </FlexRow>
                        </CustomContainer>

                        <CustomContainer
                            width='33.8'
                            minHeight='16.1'
                            radius='0.8'
                            bgColor='#FFFBEE'
                            padding='1.5'
                            style={{borderLeft: '4px solid #F2C94C'}}
                        >
                            <FlexRow 
                                justifyContent='space-between'
                                alignItems='flex-start'
                                gap='2.5'
                            >
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppSpan textSize='#282828'>Unverified Addresses</AppSpan>
                                    <AppText textSize='2.4' color='#333333' fontWeight='700'>
                                        {addressStats?.unverifiedAddresses?.total}
                                    </AppText>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit='' topMargin='0.5'>
                                    <MapIconYellow className='icon-component' />
                                </CustomContainer>
                            </FlexRow>
                            <FlexRow 
                                justifyContent='space-between' 
                                alignItems='flex-start' 
                                topMargin='3'
                                gap='3'
                                className='scroll-x-text'
                            >
                                <AppText textSize='1.2' color='#333333'>
                                    Unverification Rate
                                </AppText>
                                <FlexRow width='auto' sizeUnit='' gap='0.3'>
                                    <AppSpan textSize='1.2' color='#333333' fontWeight='700'>
                                        {addressStats?.unverifiedAddresses?.rate}%
                                    </AppSpan>
                                    <ArrowDownRight className='icon-component' />
                                </FlexRow>
                            </FlexRow>
                        </CustomContainer>
                    </FlexRow>
                </CustomContainer>
            </CustomContainer>

            <FlexRow
                gap='2'
                topMargin='2'
                justifyContent='space-between'
                className='dashboard-charts-container'
            >
                <CustomContainer
                    width='69' sizeUnit='%' 
                    className='dashboard-chart-wrapper'
                >
                    <AppSpan textSize='1.6' color='#1D1D1D' fontWeight='700'>
                        Address Verification Chart
                    </AppSpan>
                    <CustomContainer 
                        height='47.4'
                        radius='0.8'
                        shadow='0px 10px 50px 0px #0000000D'
                        bgColor='#ffffff'
                        borderColor='#FAFAFA'
                        padding='2'
                        topMargin='1'
                    >
                        <VerificationChart chartData={verificationChart?.monthlyData || []} />
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer
                    width='30' sizeUnit='%'
                    className='dashboard-chart-wrapper'
                >
                    <AppSpan textSize='1.6' color='#1D1D1D' fontWeight='700'>
                        Address Verified By Device
                    </AppSpan>
                    <CustomContainer 
                        height='47.4'
                        radius='0.8'
                        shadow='0px 10px 50px 0px #0000000D'
                        bgColor='#ffffff'
                        borderColor='#FAFAFA'
                        padding='2'
                        topMargin='1'
                    >
                        <DoughnutChart 
                            data={[deviceStats.ios, deviceStats.windows, deviceStats.macos, deviceStats.android, deviceStats.api]} 
                            labels={[`IOS - ${deviceStats.ios}%`, `Windows - ${deviceStats.windows}%`, `MACOS - ${deviceStats.macos}%`, `Android - ${deviceStats.android}%`, `API - ${deviceStats.api}%`]} 
                            bgColors={['#27AE60', '#F2994A', '#F2C94C', '#5627FF', '#000000']} 
                            borderColor={['#27AE60', '#F2994A', '#F2C94C', '#5627FF', '#000000']}
                            showLegend={true}
                            cutout='80%'
                            alignLabels='center'
                            position='bottom'
                        />
                    </CustomContainer>
                </CustomContainer>
            </FlexRow>

            <FlexRow
                gap='2'
                topMargin='2'
                justifyContent='space-between'
                alignItems='flex-start'
                className='dashboard-charts-container'
            >
                <CustomContainer
                    width='34' sizeUnit='%'
                    className='dashboard-chart-wrapper'
                >
                    <AppSpan textSize='1.6' color='#1D1D1D' fontWeight='700'>
                        Top Users By Location
                    </AppSpan>
                    <CustomContainer 
                        minHeight='47.4'
                        radius='0.8'
                        shadow='0px 10px 50px 0px #0000000D'
                        bgColor='#ffffff'
                        borderColor='#FAFAFA'
                        padding='2'
                        topMargin='1'
                    >
                        {
                            locationStats?.map((item, index) => {
                                return (
                                    <FlexRow 
                                        justifyContent='space-between'
                                        gap='2'
                                        bottomMargin='1'
                                        wrap='wrap'
                                        key={index}
                                    >
                                        <AppText textSize='1.6' color='#1D1D1D'>{item.key}</AppText>
                                        <FlexRow 
                                            width='auto' 
                                            sizeUnit='' 
                                            gap='0.5'
                                        >
                                            <AppSpan textSize='1.6'>{utility.moneyFormat(item.value)}</AppSpan>
                                            <ArrowUpRight className='icon-component' />
                                        </FlexRow>
                                    </FlexRow>
                                )
                            })
                        }
                    </CustomContainer>
                </CustomContainer>
                <CustomContainer
                    width='65' sizeUnit='%' 
                    className='dashboard-chart-wrapper'
                >
                    <AppSpan textSize='1.6' color='#1D1D1D' fontWeight='700'>
                        Users By Location
                    </AppSpan>
                    <CustomContainer 
                        height='47.4'
                        radius='0.8'
                        shadow='0px 10px 50px 0px #0000000D'
                        bgColor='#ffffff'
                        borderColor='#FAFAFA'
                        padding='2'
                        topMargin='1'
                    >
                        <img 
                            src={LocationMap} 
                            className='img-child' 
                            style={{objectFit: 'cover'}}
                        />
                    </CustomContainer>
                </CustomContainer>
            </FlexRow>
        </ScreenContainer>
    );
}